export default __webpack_public_path__ + "static/media/instantECardUsagehelpMobileHighlight.f7ed7080.png";